// Remembered "was this helpful?" votes, one per article, per browser.

// Remembered "helpful?" votes, per article, per browser. localStorage can throw
// outright (Safari private mode, host pages served with storage blocked), and a
// dead vote memory is not worth an error — fall back to asking again.
const VOTE_KEY = (id: string) => `skycell-kb-vote-${id}`;
export function readVote(id: string): boolean | null {
  try {
    const v = localStorage.getItem(VOTE_KEY(id));
    return v === null ? null : v === "1";
  } catch {
    return null;
  }
}
export function writeVote(id: string, helpful: boolean): void {
  try {
    localStorage.setItem(VOTE_KEY(id), helpful ? "1" : "0");
  } catch {
    /* votes just aren't remembered in this browser */
  }
}
